// @flow
import { put, call, takeLatest } from "redux-saga/effects";
import {
  ASSESMENT_REQUEST,
  ASSESMENT_REQUEST_SUCCESS,
  ASSESMENT_REQUEST_ERROR,
} from "../constants";
import axios from "../../../services/api";

function* assesmentRequest(data) {
  try {
    const params = new URLSearchParams();
    params.append("assesmentId", data.id);

    const response = yield call(axios.get, "/assesment-try/", {
      params,
    });
    if (response.data.error) {
      yield put({
        type: ASSESMENT_REQUEST_ERROR,
        data: response.error,
      });
    } else {
      yield put({
        type: ASSESMENT_REQUEST_SUCCESS,
        data: response.data,
      });
      data.setSelectedProgress();
    }
  } catch (error) {
    yield put({
      type: ASSESMENT_REQUEST_ERROR,
      data: error,
    });
  }
}

export default function* assesmentRequestSaga() {
  yield takeLatest(ASSESMENT_REQUEST, assesmentRequest);
}
